import { ArrowLeft } from 'lucide-react'

interface SubPageHeaderProps {
  title: string
  onBack: () => void
}

export function SubPageHeader({ title, onBack }: SubPageHeaderProps) {
  return (
    <div className="px-4 py-3 flex items-center gap-2">
      <button
        onClick={onBack}
        className="h-7 w-7 rounded-full flex items-center justify-center hover:bg-muted transition-colors"
      >
        <ArrowLeft className="h-3.5 w-3.5" />
      </button>
      <h3 className="text-sm font-medium">{title}</h3>
    </div>
  )
}
